import { Card } from 'antd';
import ContentLibraryHeader from '../../components/navigation/ContentLibraryHeader';
import SectionHeader from '../../components/panels/SectionHeader';
import SideMenu from '../../components/panels/SideMenu';
import cmsFactory from '../../components/cmsFactory';
import createComponent from '../../components/contentDisplay/dynamic';
import { createElement } from 'react';
import htmlStringToReactNodes from '../../helpers/htmlStringToReactNodes';
const LandingPage = ({
  data: {
    name,
    headerHTML,
    content,
    showSideMenu
  }
}) => {
  return <>
      <ContentLibraryHeader title={name} data-sentry-element="ContentLibraryHeader" data-sentry-source-file="[[...path]].jsx" />
      <Card data-sentry-element="Card" data-sentry-source-file="[[...path]].jsx">
        <div className="page-content">
          <div className="page-main-content">
            {headerHTML && <div className="page-desc">{htmlStringToReactNodes(headerHTML)}</div>}
            {content.map((item, key) => ({
            ...item,
            key,
            ...Object.fromEntries(Object.keys(item).filter(k => k.endsWith('HTML')).map(k => [k.replace(/HTML$/, ''), htmlStringToReactNodes(item[k])]))
          })).map(createComponent)}
          </div>
          {showSideMenu && <SideMenu />}
        </div>
      </Card>
    </>;
};
export const getStaticProps = context => ({
  props: {
    dataURL: `/content/landingPages/${context.params.path?.join('_') ?? '_'}.json`
  }
});
export const getStaticPaths = async () => ({
  fallback: false,
  paths: require('../../public/content/landingPages-paths.json')
});
export default cmsFactory(LandingPage);